<!-- Add User Modal -->
<div class="modal fade" id="addUserModal" tabindex="-1" aria-labelledby="addUserModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addUserModalLabel">Add User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="userEmail" class="form-label">Email address</label>
          <input
            type="email"
            class="form-control"
            id="userEmail"
            [(ngModel)]="userEmail"
            (ngModelChange)="onEmailChange()"
            placeholder="Enter email address">
        </div>
        <div class="mb-3" *ngIf="statusText">
          <span class="badge text-bg-{{ statusTheme }}">{{ statusText }}</span>
        </div>
        <div class="mb-3">
          <p *ngIf="selectedLocation">Adding user to: {{ getSelectedLocationName() }}</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!submitButtonEnabled"
          (click)="submitAddUser()">Add User</button>
      </div>
    </div>
  </div>
</div>
